export default __webpack_public_path__ + "static/media/sportsMob@3x.5c658508.png";